var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{ref:"input",attrs:{"api-key":"no-api-key","id":'tinymce-' + _vm.id,"init":_vm.init,"onChange":_vm.updateInput()},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }